function imgLayout() {
  const cards = document.querySelectorAll('.p-environment-intro__img');
  const wrap = document.querySelector('.p-environment-intro__img-in');

  const mq = window.matchMedia('(min-width: 1024px)');

  if (cards.length > 0 && wrap && mq.matches) {
    let isPlayed = false;
    let lockedScrollDeltaY = 0;
    let touchStartY = 0;
    let prevHtmlOverflow = '';
    let prevBodyOverflow = '';

    function preventWheelScroll(e) {
      lockedScrollDeltaY += e.deltaY;
      e.preventDefault();
    }

    function onTouchStart(e) {
      touchStartY = e.touches[0].clientY;
    }

    function preventTouchScroll(e) {
      const currentY = e.touches[0].clientY;
      lockedScrollDeltaY += touchStartY - currentY;
      touchStartY = currentY;
      e.preventDefault();
    }

    function lockScroll() {
      lockedScrollDeltaY = 0;
      prevHtmlOverflow = document.documentElement.style.overflow;
      prevBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', preventWheelScroll, { passive: false });
      document.addEventListener('touchstart', onTouchStart, { passive: true });
      document.addEventListener('touchmove', preventTouchScroll, { passive: false });
    }

    function unlockScroll() {
      const currentY = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const nextScrollY = Math.max(0, Math.min(currentY + lockedScrollDeltaY, maxScroll));

      document.removeEventListener('wheel', preventWheelScroll);
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', preventTouchScroll);
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;

      window.scrollTo(0, nextScrollY);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isPlayed) {
          isPlayed = true;

          const rect = wrap.getBoundingClientRect();
          const offset = 280;
          const targetY = rect.top + window.scrollY - offset;

          window.scrollTo({
            top: targetY,
            behavior: 'auto',
          });

          // scroll完了を1フレーム待つ
          setTimeout(() => {
            lockScroll(); // ← targetY渡さない
          }, 50);

          cards.forEach((card, i) => {
            setTimeout(() => {
              card.classList.add('is-show');
            }, i * 300);
          });

          const totalTime = 800 + (cards.length - 1) * 300;

          setTimeout(() => {
            unlockScroll();
          }, totalTime);

          observer.unobserve(wrap);
        }
      },
      {
        rootMargin: '0px 0px -500px 0px',
      }
    );

    observer.observe(wrap);
  }
}

export { imgLayout };
